import { max, orderBy } from 'lodash';
import React from 'react';

import { Specialization } from '../components/gw2components';

export type Difficulties = {
  level: string;
};

export type Group<T> = {
  fieldValue: string;
  edges: Edge<T>[];
};

type Edge<T> = {
  node: T;
};

export interface Category<T> {
  name: string;
  path: string;
  renderNavigationText: ({
    title,
    specialization,
    difficulties,
  }: {
    title: string;
    specialization: string;
    difficulties: Difficulties[];
  }) => React.ReactNode;
  orderEdges: (edges: Edge<T>[]) => any[];
  orderGroups?: (groups: Group<T>[]) => Group<T>[];
}

export const guides: Category<Queries.GuidesSkeletonFragment> = {
  name: 'Guides',
  path: '/guides',
  renderNavigationText: ({ title }) => title,
  orderEdges: (edges) =>
    orderBy(
      edges,
      ({ node: { frontmatter } }) => frontmatter?.date?.trim() || '',
      'desc',
    ),
};

export const cmguides: Category<{
  frontmatter: { date: string | null } | null;
}> = {
  name: 'CM-Guides',
  path: '/cm-guides',
  renderNavigationText: ({ title }) => title,
  orderEdges: (edges) =>
    orderBy(
      edges,
      ({ node: { frontmatter } }) => frontmatter?.date?.trim(),
      'desc',
    ),
};

export const builds: Category<Queries.BuildsSkeletonFragment> = {
  name: 'Builds',
  path: '/builds',
  renderNavigationText: ({ title, specialization }) => {
    /*
    const suitableBoons = boons
      ? boons
          .filter(
            (boon) =>
              ['group', 'party'].includes(boon.variant) &&
              ['Alacrity', 'Quickness'].includes(boon.name) &&
              parseFloat(boon.uptime) > 90,
          )
          .map((boon) => boon.name)
      : []
    */
    return (
      <>
        <Specialization
          // @ts-ignore
          disableText
          name={specialization}
        />{' '}
        {title}
      </>
    );
  },
  orderGroups: (groups) =>
    orderBy(groups, ({ fieldValue }) => {
      switch (fieldValue) {
        case 'Power Damage':
          return 0;
        case 'Condi Damage':
          return 1;
        case 'Hybrid':
          return 2;
        case 'Support':
          return 3;
        case 'Other':
          return 4;
        default:
          return 5;
      }
    }),
  orderEdges: (edges) =>
    orderBy(edges, ({ node: { frontmatter } }) => frontmatter?.title, 'asc'),
};

export const fractals: Category<Queries.FractalsSkeletonFragment> = {
  name: 'Fractals',
  path: '/fractals',
  renderNavigationText: ({ title, difficulties }) =>
    `${
      difficulties && difficulties.length
        ? `${difficulties.map(({ level }) => level).join(',')} `
        : ''
    }${title}`,
  orderEdges: (edges) =>
    orderBy(
      edges,
      ({ node: { frontmatter } }) =>
        frontmatter?.difficulties && frontmatter.difficulties.length
          ? max(frontmatter?.difficulties.map((diff) => diff?.level))
          : 0,
      'desc',
    ),
};

export default [guides, builds, fractals, cmguides];
